export default "__VITE_ASSET__DLEAc50j__"